import { render } from "./PayoutCompensationDetailRow.vue?vue&type=template&id=f1464fe2&scoped=true&ts=true"
import script from "./PayoutCompensationDetailRow.vue?vue&type=script&lang=ts"
export * from "./PayoutCompensationDetailRow.vue?vue&type=script&lang=ts"

import "./PayoutCompensationDetailRow.vue?vue&type=style&index=0&id=f1464fe2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1464fe2"]])

export default __exports__